import { makeRequest } from "../http-common";

const ReferenceDataService = {

    status_codes() {
        return [
            { id: 1, label: "new", description: "task has not been accepted", variant: "success" },
            { id: 2, label: "accepted", description: "user confirmed task receipt", variant: "success" },
            { id: 3, label: "in progress", description: "task is being worked on", variant: "success" },
            { id: 4, label: "waiting", description: "waiting on someone else to continue", variant: "danger" },
            { id: 5, label: "completed", description: "user has finished this task", variant: "warning" },
            { id: 6, label: "reopened", description: "completed task that was not completed to owner satisfaction", variant: "danger" },
            { id: 7, label: "declined", description: "user does not want to work task", variant: "secondary" },
            { id: 8, label: "closed", description: "only admin or creator can close a task", variant: "secondary" }
        ]
    },

    importance_codes() {
        return [
            { id: 1, label: "Low", icon: "fas fa-arrow-circle-down", class: "text-primary" },
            { id: 2, label: "Normal", icon: "fas fa-minus-circle", class: "text-secondary" },
            { id: 3, label: "High", icon: "fas fa-arrow-circle-up", class: "text-warning" },
            { id: 4, label: "Critical", icon: "fas fa-exclamation-circle", class: "text-danger" },
        ]
    },

    true_false_codes() {
        return [
            { value: 0, text: "False" },
            { value: 1, text: "True" }
        ]
    },

    color_codes() {
        return {
            1: "None",
            2: "Red",
            3: "Blue",
            4: "Green",
            5: "Yellow"
        }

    },

    aspect_icons() {
        return {
            "user": "fa-solid fa-user",
            "fire": "fa-solid fa-fire",
            "road": "fa-solid fa-road",
            "briefcase": "fa-solid fa-briefcase",
            "lock": "fa-solid fa-lock",
            "home": "fa-solid fa-house",
            "header": "fa-solid fa-heading",
            "signal": "fa-solid fa-signal",
            "tower": "fa-solid fa-chess-rook",
            "tag": "fa-solid fa-utensils",
            "transfer": "fa-solid fa-arrow-right-arrow-left",
            "list": "fa-solid fa-file-invoice",
          }
    },

    policy_status_codes() {
        return [
            { id: 1, label: "New", allowed: 1 },
            { id: 2, label: "Pending Underwriting", allowed: 1 },
            { id: 3, label: "Approved", allowed: 0 },
            { id: 4, label: "Expired", allowed: 0 },
            { id: 5, label: "Cancelled", allowed: 0 },
            { id: 6, label: "Quoting", allowed: 1 },
            { id: 7, label: "Quoted", allowed: 1 },
            { id: 8, label: "Unbound Renewal", allowed: 0 }
        ]

    },

    policy_source_codes() {
        return [
            { value: "3e0f82c2-bf41-11e3-aad8-cf73cfb7279e", text: "Cold Call" },
            { value: "439739ec-bf41-11e3-aad8-cf73cfb7279e", text: "Existing Customer" },
            { value: "49bd71e2-bf41-11e3-aad8-cf73cfb7279e", text: "Self Generated" },
            { value: "52df1afa-bf41-11e3-aad8-cf73cfb7279e", text: "Employee" },
            { value: "605a196e-bf41-11e3-aad8-cf73cfb7279e", text: "Other" },
            { value: "70b3f560-bf40-11e3-aad8-cf73cfb7279e", text: "Search Engine" },
            { value: "749c1536-bf40-11e3-aad8-cf73cfb7279e", text: "Direct Mail" },
            { value: "7e2d3e68-bf40-11e3-aad8-cf73cfb7279e", text: "Trade Show" },
            { value: "8256ae20-bf40-11e3-aad8-cf73cfb7279e", text: "Email" },
            { value: "860548ce-bf40-11e3-aad8-cf73cfb7279e", text: "Word of Mouth" },
            { value: "bea873d1-7092-11e6-9934-652aa3b292c7", text: "Covered California Storefront" }
        ]
    },

    theme_codes() {
        return {
            cerulean: "Cerulean",
            cosmo: "Cosmo",
            cyborg: "Cyborg",
            darkly: "Darkly",
            flatly: "Flatly",
            journal: "Journal",
            litera: "Litera",
            lumen: "Lumen",
            lux: "Lux",
            materia: "Materia",
            minty: "Minty",
            pulse: "Pulse",
            sandstone: "Sandstone",
            simplex: "Simplex",
            sketchy: "Sketchy",
            slate: "Slate",
            solar: "Solar",
            spacelab: "Spacelab",
            superhero: "Superhero",
            united: "United",
            yeti: "Yeti"
        };
    },

    policy_commission_type_codes() {
        return [
            { value: "percent", text: "Percent" },
            { value: "flat", text: "Flat" }
        ]
    },

    policy_commission_status_codes() {
        return [
            { value: 1, text: "Unknown" },
            { value: 2, text: "Commission Retained" },
            { value: 3, text: "Commission Pending" },
            { value: 4, text: "Commission Received" }
        ]
    },

    policy_coverageline_codes() {
        return [
            { value: 1, text: "Personal" },
            { value: 2, text: "Commercial" }
        ]
    },

    policy_payment_types() {
        return {
            1: "Check",
            2: "Credit Card",
            3: "Financing",
            4: "Trust Check",
            5: "Return Premium from Insurance Company",
            6: "Rebate to Client",
            7: "ACH",
            8: "Cash",
            9: "Carrier Direct Billing"
        }
    },

    policy_business_source_codes() {
        return [
            { value: 1, text: "New Business" },
            { value: 2, text: "Renewal" }
        ]
    },

    policy_linesofcoverage() {
        return makeRequest('get', '/policy/linesofcoverage');
    },

    policy_risktype_codes() {
        return makeRequest('get', '/policy/risktypes');
    },

    insurance_companies() {
        return makeRequest('get', '/aspect/bytype/a87f5e62-4f0f-11e4-863c-449b3f674833');
    },

    agencies() {
        return makeRequest('get', '/aspect/bytype/37fd376e-eb47-4df8-bb0c-6f65d56502bf');
    },

    avatars() {

        return {
            '/images/avatar/avatar.png': 'Avatar',
            '/images/avatars/baseball.png': 'Baseball',
            '/images/avatars/bee.png': 'Bee',
            '/images/avatars/boat.png': 'Boat',
            '/images/avatars/burger.png': 'Burger',
            '/images/avatars/caterpillar.png': 'Caterpillar',
            '/images/avatars/cloud.png': 'Cloud',
            '/images/avatars/cookie.png': 'Cookie',
            '/images/avatars/dolphin.png': 'Dolphin',
            '/images/avatars/elephant.png': 'Elephant',
            '/images/avatars/fish.png': 'Fish',
            '/images/avatars/football.png': 'Football',
            '/images/avatars/glasses.png': 'Glasses',
            '/images/avatars/horse.png': 'Horse',
            '/images/avatars/icecream.png': 'Icecream',
            '/images/avatars/koala.png': 'Koala',
            '/images/avatars/monkey.png': 'Monkey',
            '/images/avatars/mouse.png': 'Mouse',
            '/images/avatars/mug.png': 'Mug',
            '/images/avatars/panda.png': 'Panda',
            '/image/avatars/strawberry.png': 'Strawberry',
            '/images/avatars/sunglasses.png': 'Sunglasses',
            '/images/avatars/turtle.png': 'Turtle',
            '/images/avatars/unicorn.png': 'Unicorn',
            '/images/avatars/watermelon.png': 'Watermelon'

        }
    },
}

export default ReferenceDataService;